//导入插件
import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store"
import { clearUserInfo } from "@/utils"
import { Message } from 'element-ui'

//导入页面
const Login = () => import("@/views/Login.vue"); // 登录
const Home = () => import("@/views/Home.vue"); // 首页
//第一个页面
const FirstPage = () => import("@/views/child/FirstPage.vue"); // 首页
//用户引导
const Driver = () => import("@/views/child/driver/Driver.vue"); // 引导指南

// 系统设置
const OrganMan = () => import("@/views/child/member/OrganMan.vue"); // 机构管理
const Role = () => import("@/views/child/limit/Role.vue"); // 角色管理
const departmentLits = () => import("@/views/child/limit/departmentLits.vue"); // 角色管理
const AddRole = () => import("@/views/child/limit/AddRole.vue"); // 角色信息管理
const Admin = () => import("@/views/child/limit/Admin.vue"); // 管理员管理
const PathMan = () => import("@/views/child/limit/PathMan.vue"); // 路径管理
const PayType = () => import("@/views/child/member/PayType.vue"); // 支付类型
const AppMan = () => import("@/views/child/system/AppMan.vue"); // App更新
const AppManYwt = () => import("@/views/child/system/AppManYwt.vue"); // 业务通App更新
const GetGoods = () => import("@/views/child/product/GetGoods.vue"); // 商品到货管理
const SysSetting = () => import("@/views/child/system/SysSetting.vue"); // 系统设置
const AppFloorMan = () => import("@/views/child/system/AppFloorMan.vue"); // App楼层
const LogisticsCompany = () => import("@/views/child/system/LogisticsCompany.vue"); // 物流公司管理
const LogisticsPostage = () => import("@/views/child/system/LogisticsPostage.vue"); // 物流公司邮费管理
// const OrderListcaowi = () => import("@/views/child/order/OrderListcaowi.vue"); // 财务订单列表

// 商城管理
const MallConfig = () => import("@/views/child/system/MallConfig.vue"); // 商城配置
const FloorSetting = () => import("@/views/child/system/FloorSetting.vue"); // 楼层设置
const FloorGoods = () => import("@/views/child/system/FloorGoods.vue"); // 楼层商品
const FloorImgs = () => import("@/views/child/system/FloorImgs.vue"); // 楼层图片
const NavList = () => import("@/views/child/system/NavList.vue"); // PC导航管理
const AppLink = () => import("@/views/child/system/AppLink.vue"); // APP链接管理
const ModeList = () => import("@/views/child/system/ModeList.vue"); // APP首页模块
const AppFun = () => import("@/views/child/system/AppFun.vue"); // APP个人模块
const SearchHot = () => import("@/views/child/system/SearchHot.vue"); // 搜索热词
const Advertising = () => import("@/views/child/system/Advertising.vue"); // 广告位设置
const zzgl = () => import("@/views/child/system/zzgl.vue"); // 企业资质管理
const Recommend = () => import("@/views/child/system/Recommend.vue"); // 推荐专区
const Postage = () => import("@/views/child/system/Postage.vue"); // 邮费管理
// 客户管理
const MemList = () => import("@/views/child/member/MemList.vue"); // 客户列表
const MemInfo = () => import("@/views/child/member/MemInfo.vue"); // 客户详情
const CustomersTag= () => import("@/views/child/member/CustomersTag.vue"); // 客户标签
const BindUser = () => import("@/views/child/member/BindUser.vue"); // 绑定客户账号
const AgencyMembers = () => import("@/views/child/member/agencyMembers.vue"); // 机构列表
const EntMemInfo = () => import("@/views/child/member/EntMemInfo.vue"); // 机构客户详情
const Audit = () => import("@/views/child/member/Audit.vue"); // 注册审核
const RegistAudit = () => import("@/views/child/member/RegistAudit.vue"); // 注册审核
const Certificate = () => import("@/views/child/member/Certificate.vue"); // 注册资质
const RunRange = () => import("@/views/child/member/RunRange.vue"); // 经营范围
const MemClassify = () => import("@/views/child/member/MemClassify.vue"); // 客户分类
const MemGroup = () => import("@/views/child/member/MemGroup.vue"); // 客户分组
const BindUserGroup = () => import("@/views/child/member/BindUserGroup.vue"); // 绑定客户分组
const CertExpired = () => import("@/views/child/member/CertExpired.vue"); // 资质查询
const CertExpiredDetails = () => import("@/views/child/member/CertExpiredDetails.vue"); // 资质查询详情
const RegistCertificate = () => import("@/views/child/member/RegistCertificate.vue"); // 资质维护
const ERPCertificate = () => import("@/views/child/member/ERPCertificate.vue"); // erp对应商城分类
// 客户管理
const MemTopUp = () => import("@/views/child/member/MemTopUp.vue"); // 客户充值
const RechargeFlow = () => import("@/views/child/member/RechargeFlow.vue"); // 客户充值流水
// 商品管理
const ProductList = () => import("@/views/child/product/ProductList.vue"); // 商品列表
const AddProduct = () => import("@/views/child/product/AddProduct.vue"); // 商品管理
const ProductImgList = () => import("@/views/child/product/ProductImgList.vue"); // 商品图片管理
const AddImgProduct = () => import("@/views/child/product/AddImgProduct.vue"); // 商品图片管理
const ProductAreaPrice = () => import("@/views/child/product/ProductAreaPrice.vue"); // 商品区域价格
const PriceLevel = () => import("@/views/child/product/PriceLevel.vue"); // 价格等级
const ProductClassify = () => import("@/views/child/product/ProductClassify.vue"); // 商品分类
const ClassifyGoods = () => import("@/views/child/product/ClassifyGoods.vue"); // 商品分类的商品
const GoodsGroup = () => import("@/views/child/product/GoodsGroup.vue"); // 商品分组
const AddGoodsGroup = () => import("@/views/child/product/AddGoodsGroup.vue"); // 编辑商品分组
const ControlGoods = () => import("@/views/child/product/ControlGoods.vue"); // 商品控销
const PrefectureGoods = () => import("@/views/child/prefecture/PrefectureGoods.vue"); // 品牌商品
const PrefectureList = () => import("@/views/child/prefecture/PrefectureList.vue"); // 品牌管理
const HomeBrand = () => import("@/views/child/prefecture/HomeBrand.vue"); // 首页品牌管理
const GiftList = () => import("@/views/child/product/GiftList.vue"); // 赠品管理
const RecommendGoods = () => import("@/views/child/product/RecommendGoods.vue"); // 推荐商品管理
const CommentAudit = () => import("@/views/child/comment/CommentAudit.vue"); // 商品评论
const AddConGoods = () => import("@/views/child/product/AddConGoods.vue"); // 添加商品控销
const AddGift = () => import("@/views/child/product/AddGift.vue"); // 添加赠品
const AddIntGoods = () => import("@/views/child/product/AddIntGoods.vue"); // 添加积分商品
const AddProClassify = () => import("@/views/child/product/AddProClassify.vue"); // 新增商品分类
const AddComm = () => import("@/views/child/product/AddComm.vue"); // 新增推荐商品
const GoodsTag = () => import("@/views/child/product/GoodsTag.vue"); // 商品标签
const WantBuy = () => import("@/views/child/product/WantBuy.vue"); // 求购商品
const InventoryUsage = () => import("@/views/child/product/InventoryUsage.vue"); // 商品占用库存查询
const LimitMan = () => import("@/views/child/product/LimitMan.vue"); // 限销管理
const LimitManCx = () => import("@/views/child/product/LimitManCx.vue"); // 限销管理商品查询
const GoodsControl = () => import("@/views/child/product/GoodsControl.vue"); // 商品管控

// 分组控销
const ControlGroup = () => import("@/views/child/control/ControlGroup.vue"); // 控销分组
const ControlGroupInfo = () => import("@/views/child/control/ControlGroupInfo.vue"); // 控销分组管理
const GroupBind = () => import("@/views/child/control/GroupBind.vue"); // 分组关系
// 文章管理
const ArticleList = () => import("@/views/child/article/ArticleList.vue"); // 文章列表
const AddArticle = () => import("@/views/child/article/AddArticle.vue"); // 编辑文章
const ArticleSort = () => import("@/views/child/article/ArticleSort.vue"); // 文章分类
// 积分商城
const IntegralGoods = () => import("@/views/child/product/IntegralGoods.vue"); // 积分商品
const SignRule = () => import("@/views/child/sign/SignRule.vue"); // 签到规则
const SignFun = () => import("@/views/child/sign/SignFun.vue"); // 签到功能
const IntegralList = () => import("@/views/child/order/IntegralList.vue"); // 积分订单
const IntegralWater = () => import("@/views/child/order/IntegralWater.vue"); // 积分流水
// 促销管理
const Schemes = () => import("@/views/child/scheme/Schemes.vue"); // 方案列表
const Single = () => import("@/views/child/scheme/Single.vue"); // 单品方案设计
const Group = () => import("@/views/child/scheme/Group.vue"); // 组合商品

const PromActivityList = () => import("@/views/child/scheme/PromActivityList.vue"); // 促销活动管理
const PromRuleList = () => import("@/views/child/scheme/PromRuleList.vue"); // 促销规则管理
const AddPromActivity = () => import("@/views/child/scheme/AddPromActivity.vue"); // 新增促销活动
const AddPromRule = () => import("@/views/child/scheme/AddPromRule.vue"); // 新增促销规则
const FocusBuy = () => import("@/views/child/scheme/FocusBuy.vue"); // 集采列表
const AddFocusBuy = () => import("@/views/child/scheme/AddFocusBuy.vue"); // 新增集采
const SpellGroup = () => import("@/views/child/scheme/SpellGroup.vue"); // 拼团列表
const AddSpellGroup = () => import("@/views/child/scheme/AddSpellGroup.vue"); // 新增拼团
const PromAmount = () => import("@/views/child/scheme/PromAmount.vue"); // 订单累计金额促销
const AddAmount = () => import("@/views/child/scheme/AddAmount.vue"); // 新增订单累计金额促销活动
const Coupons = () => import("@/views/child/coupon/Coupons.vue"); // 优惠券列表
const GiveOut = () => import("@/views/child/coupon/GiveOut.vue"); // 优惠券下发
const CouponDetail = () => import("@/views/child/coupon/CouponDetail.vue"); // 优惠券详情
const UserCoupon = () => import("@/views/child/coupon/UserCoupon.vue"); // 客户优惠券
const Presell = () => import("@/views/child/scheme/Presell.vue"); // 预购商品
const PresellForm = () => import("@/views/child/scheme/PresellForm.vue"); // 预购商品表达
const PromMan = () => import("@/views/child/scheme/PromMan.vue"); // 新的促销活动管理
const PromForm = () => import("@/views/child/scheme/PromForm.vue"); // 新增促销活动

// 订单管理
const OrderList = () => import("@/views/child/order/OrderList.vue"); // 订单列表
const OrderListcaowi = () => import("@/views/child/order/OrderListcaowi.vue"); // 订单列表
const OrderInfo = () => import("@/views/child/order/OrderInfo.vue"); // 订单详情
const ReturnList = () => import("@/views/child/order/ReturnList.vue"); // 退货申请
const ChuFangList = () => import("@/views/child/order/ChuFangList.vue"); // 处方申请
const OrderRefund = () => import("@/views/child/order/OrderRefund.vue"); // 订单退款
const FocusOrder = () => import("@/views/child/order/FocusOrder.vue"); // 集采订单列表
const SpellOrder = () => import("@/views/child/order/SpellOrder.vue"); // 拼团订单列表
const RetreatAudit = () => import("@/views/child/order/RetreatAudit.vue"); // 退单审核
const RefundRequest = () => import("@/views/child/order/RefundRequest.vue"); // 退款审核
const RefundRequestDetail = () => import("@/views/child/order/RefundRequestDetail.vue"); // 退款审核详情
const PayQuery = () => import("@/views/child/order/PayQuery.vue"); // 在线支付查询
const InvoiceRequestRecord = () => import("@/views/child/order/InvoiceRequestRecord.vue"); // 发票申请记录
const ExpenseWater = () => import("@/views/child/order/ExpenseWater.vue"); // 消费流水
const GiftExchange = () => import("@/views/child/order/GiftExchange.vue"); // 消费流水
const OrderSummary = () => import("@/views/child/order/OrderSummary.vue"); // 订单汇总
const OrderDetails = () => import("@/views/child/order/OrderDetails.vue"); // 订单明细查询

// 图片管理
const ImgMan = () => import("@/views/child/image/ImgMan.vue"); // 图片管理
const PcBannerList = () => import("@/views/child/image/PcBannerList.vue"); // PC轮播图管理
const BannerList = () => import("@/views/child/image/BannerList.vue"); // APP轮播图管理
const FloorList = () => import("@/views/child/image/FloorList.vue"); // 楼层图片
const PcBanner = () => import("@/views/child/image/PcBanner.vue"); // PC横幅图片
const AppBanner = () => import("@/views/child/image/AppBanner.vue"); // APP横幅图片
const StudyBanner = () => import("@/views/child/image/StudyBanner.vue"); // 要学习banner图片维护
const AppAdvertImgs = () => import("@/views/child/image/AppAdvertImgs.vue"); // APP首页广告图详情
// 数据分析
const DataCount = () => import("@/views/child/analyze/DataCount.vue"); // 数据统计
const Collect = () => import("@/views/child/analyze/Collect.vue"); // 收藏统计
const OrderFrequency = () => import("@/views/child/analyze/OrderFrequency.vue"); // 下单频率分析
const OrdersellAnalysis = () => import("@/views/child/analyze/OrdersellAnalysis.vue"); // 订单数据汇总
const OrderSource = () => import("@/views/child/analyze/OrderSource.vue"); // 订单来源统计
const OrderTime = () => import("@/views/child/analyze/OrderTime.vue"); // 下单时间统计
const SearchFrequency = () => import("@/views/child/analyze/SearchFrequency.vue"); // 搜索频率分析
const ShopCart = () => import("@/views/child/analyze/ShopCart.vue"); // 购物车商品分析
const TypePay = () => import("@/views/child/analyze/TypePay.vue"); // 支付类型统计
const UnitPrice = () => import("@/views/child/analyze/UnitPrice.vue"); // 客单价统计
const LoginList = () => import("@/views/child/analyze/LoginList.vue"); // 登录统计
const OrderAnalysis = () => import("@/views/child/analyze/OrderAnalysis.vue"); // 订单分析
const UserAnalysis = () => import("@/views/child/analyze/UserAnalysis.vue"); // 客户分析
const GoodsAnalysis = () => import("@/views/child/analyze/GoodsAnalysis.vue"); // 商品分析
const UserGoods = () => import("@/views/child/analyze/UserGoods.vue"); // 客户商品
// 接口查询
const OrderInterface = () => import("@/views/child/interface/OrderInterface.vue"); // 订单接口
const OrderInterfaceInfo = () => import("@/views/child/interface/OrderInterfaceInfo.vue"); // 订单接口详情
const GoodsInterface = () => import("@/views/child/interface/GoodsInterface.vue"); // 商品接口
const UserInterface = () => import("@/views/child/interface/UserInterface.vue"); // 客户接口
const PriceInterface = () => import("@/views/child/interface/PriceInterface.vue"); // 价格接口
const MemPriceList = () => import("@/views/child/member/MemPriceList.vue"); // 客户余额提现申请表
// 专区管理
const PharmacyZone = () => import("@/views/child/prefecture/PharmacyZone.vue"); // 药店专区管理
const ExpertList = () => import("@/views/child/prefecture/ExpertList.vue"); // 自定义专区列表
const OutpatientZone = () => import("@/views/child/prefecture/OutpatientZone.vue"); // 自定义专区商品
const ThemeTem = () => import("@/views/child/theme/ThemeTem.vue"); // 主题活动模板
const ThemePro = () => import("@/views/child/theme/ThemePro.vue"); // 主题商品组合
const TemplateBind = () => import("@/views/child/theme/TemplateBind.vue"); // 模板绑定
const AddTemplate = () => import("@/views/child/theme/AddTemplate.vue"); // 模板管理
const AddTemPro = () => import("@/views/child/theme/AddTemPro.vue"); // 绑定商品

// 日志
const LogIp = () => import("@/views/child/log/LogIp.vue"); // 用户IP捕捉记录
const HandleLog = () => import("@/views/child/log/HandleLog.vue"); // 用户IP捕捉记录
//充值管理
const TopupList = () => import("@/views/child/topup/TopupList.vue"); // 充值活动
const TopupWater = () => import("@/views/child/topup/TopupWater.vue"); // 充值流水
//抽奖管理
const PrizeList = () => import("@/views/child/lottery/PrizeList.vue"); // 奖品列表
const PrizeRule = () => import("@/views/child/lottery/PrizeRule.vue"); // 抽奖规则
const Recorded = () => import("@/views/child/lottery/Recorded.vue"); // 中奖记录
//资讯管理
const AddAdvisory = () => import("@/views/child/advisory/AddAdvisory.vue"); // 资讯管理
const AdvisoryMan = () => import("@/views/child/advisory/AdvisoryMan.vue"); // 资讯管理
const Helps = () => import("@/views/child/advisory/Helps.vue"); // 帮助中心
const ViewDoc = () => import("@/views/child/advisory/ViewDoc.vue"); // 帮助文档列表
const EditDoc = () => import("@/views/child/advisory/EditDoc.vue"); // 帮助文档编辑
const InformMan = () => import("@/views/child/inform/InformMan.vue"); // 推送管理
const LeavingMsg = () => import("@/views/child/advisory/LeavingMsg.vue"); // 留言管理
//业务员管理
const SalesmanList = () => import("@/views/child/salesman/SalesmanList.vue"); // 业务员列表
const DuoJiSalesmanList = () => import("@/views/child/salesman/DuoJiSalesmanList.vue"); // 多级业务员列表
const DuoJiSalesBangDingGoods = () => import("@/views/child/salesman/DuoJiSalesBangDingGoods.vue"); // 多级业务员绑定商品
const DuoJiSalesChangeLeader = () => import("@/views/child/salesman/DuoJiSalesChangeLeader.vue"); // 多级业务员更换业务员上级
const DuoJiSalesChangeTransfer = () => import("@/views/child/salesman/DuoJiSalesChangeTransfer.vue"); // 多级业务员迁移下级
const SalesmanListDoict = () => import("@/views/child/salesman/SalesmanListDoict.vue"); // 业务员医生列表

const SalesmanUser = () => import("@/views/child/salesman/SalesmanUser.vue"); // 业务员客户列表
const SalesmanReg = () => import("@/views/child/salesman/SalesmanReg.vue"); // 业务员注册
const SalesmanAudit = () => import("@/views/child/salesman/SalesmanAudit.vue"); // 业务员审核
const SalesmanGroup = () => import("@/views/child/salesman/SalesmanGroup.vue"); // 业务员分组
const BindGroup = () => import("@/views/child/salesman/BindGroup.vue"); // 绑定分组
const SalesmanOrderList = () => import("@/views/child/salesman/SalesmanOrderList.vue"); // 业务员订单列表
const SalesmanCommodity = () => import("@/views/child/salesman/SalesmanCommodity.vue"); // 业务员绑定商品
const BindingSalesman = () => import("@/views/child/salesman/BindingSalesman.vue"); // 分组绑定业务员
const SalesmanRole = () => import("@/views/child/salesman/SalesmanRole.vue"); // 业务员角色
const Dotoclist = () => import("@/views/child/salesman/Dotoclist.vue"); // 医生列表
const DoictSickLits = () => import("@/views/child/salesman/DoictSickLits.vue"); // 患者列表
// const DoictSickLits = () => import("@/views/child/salesman/DoictSickLits.vue"); // 患者列表

// 健康知识

const Knowledgelits = () => import("@/views/child/salesman/Knowledgelits.vue"); // 健康知识
const KnowleDoc = () => import("@/views/child/advisory/KnowleDoc.vue"); // 帮助文档列表
const EditKnow = () => import("@/views/child/advisory/EditKnow.vue"); // 帮助文档编辑

// 首页编辑
const homeSystem = () => import("@/views/child/advisory/homeSystem.vue"); // 资讯管理
const advisoryManLits = () => import("@/views/child/advisory/advisoryManLits.vue"); // 资讯管理

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}


//注册到vue
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/login"
  }, {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "登录"
    }
  }, {
    path: "/home",
    component: Home,
    children: [
      {
        path: "",
      },
      {
        path: "firstPage",
        name: "firstPage",
        component: FirstPage,
        meta: {
          title: "首页"
        }
      },
      {
        path: "memPriceList",
        name: "memPriceList",
        component: MemPriceList,
        meta: {
          title: "客户余额提现申请",
        },
      },

      {
        path: "driver",
        name: "driver",
        component: Driver,
        meta: {
          title: "引导指南"
        }
      },
      {
        path: "sysSetting",
        name: "sysSetting",
        component: SysSetting,
        meta: {
          title: "系统设置"
        }
      }, {
        path: "floorSetting",
        name: "floorSetting",
        component: FloorSetting,
        meta: {
          title: "楼层设置"
        }
      }, {
        path: "floorGoods",
        name: "floorGoods",
        component: FloorGoods,
        meta: {
          title: "楼层商品"
        }
      },{
        path: "floorImgs",
        name: "floorImgs",
        component: FloorImgs,
        meta: {
          title: "楼层图片"
        }
      }, {
        path: "navList",
        name: "navList",
        component: NavList,
        meta: {
          title: "PC导航管理"
        }
      }, {
        path: "appLink",
        name: "appLink",
        component: AppLink,
        meta: {
          title: "APP链接管理"
        }
      }, {
        path: "OrderListcaowi",
        name: "OrderListcaowi",
        component: OrderListcaowi,
        meta: {
          title: "提现查询",
        },
      }, {
        path: "modeList",
        name: "modeList",
        component: ModeList,
        meta: {
          title: "APP首页模块"
        }
      }, {
        path: "appFun",
        name: "appFun",
        component: AppFun,
        meta: {
          title: "APP个人模块"
        }
      }, {
        path: "searchHot",
        name: "searchHot",
        component: SearchHot,
        meta: {
          title: "搜索热词"
        }
      }, {
        path: "recommend",
        name: "recommend",
        component: Recommend,
        meta: {
          title: "推荐专区"
        }
      }, {
        path: "postage",
        name: "postage",
        component: Postage,
        meta: {
          title: "邮费管理"
        }
      }, {
        path: "advertising",
        name: "advertising",
        component: Advertising,
        meta: {
          title: "广告位设置"
        }
      },
      {
        path: "appFloorMan",
        name: "appFloorMan",
        component: AppFloorMan,
        meta: {
          title: "App楼层"
        }
      },
      {
        path: "zzgl",
        name: "zzgl",
        component: zzgl,
        meta: {
          title: "资质管理"
        }
      },

      {
        path: "logisticsCompany",
        name: "logisticsCompany",
        component: LogisticsCompany,
        meta: {
          title: "物流公司管理"
        }
      },
      {
        path: "logisticsPostage",
        name: "logisticsPostage",
        component: LogisticsPostage,
        meta: {
          title: "邮费管理"
        }
      },
      {
        path: "mallConfig",
        name: "mallConfig",
        component: MallConfig,
        meta: {
          title: "商城配置"
        }
      }, {
        path: "appMan",
        name: "appMan",
        component: AppMan,
        meta: {
          title: "App更新",
          show: true
        }
      }, {
        path: "appManYwt",
        name: "appManYwt",
        component: AppManYwt,
        meta: {
          title: "业务通App更新"
        }
      }, {
        path: "admin",
        name: "admin",
        component: Admin,
        meta: {
          title: "管理员管理"
        }
      }, {
        path: "role",
        name: "role",
        component: Role,
        meta: {
          title: "角色管理"
        }
      }, {

        path: "departmentLits",
        name: "departmentLits",
        component: departmentLits,
        meta: {
          title: "部门管理"
        }
      }, {
        path: "pathMan",
        name: "pathMan",
        component: PathMan,
        meta: {
          title: "路径管理"
        }
      }, {
        path: "payType",
        name: "payType",
        component: PayType,
        meta: {
          title: "支付类型"
        }
      }, {
        path: "addRole",
        name: "addRole",
        component: AddRole,
        meta: {
          title: "信息管理",
          show: true
        }
      }, {
        path: "audit",
        name: "audit",
        component: Audit,
        meta: {
          title: "注册审核"
        }
      }, {
        path: "memList",
        name: "memList",
        component: MemList,
        meta: {
          title: "客户列表"
        }
      }, {
        path: "memInfo",
        name: "memInfo",
        component: MemInfo,
        meta: {
          title: "客户详情"
        }
      },{
        path: "customersTag",
        name: "customersTag",
        component: CustomersTag,
        meta: {
          title: "客户标签"
        }
      },{
        path: "bindUser",
        name: "bindUser",
        component: BindUser,
        meta: {
          title: "绑定客户账号"
        }
      }, {
        path: "agencyMembers",
        name: "agencyMembers",
        component: AgencyMembers,
        meta: {
          title: "机构客户列表"
        }
      }, {
        path: "entMemInfo",
        name: "entMemInfo",
        component: EntMemInfo,
        meta: {
          title: "客户详情"
        }
      }, {
        path: "organMan",
        name: "organMan",
        component: OrganMan,
        meta: {
          title: "机构管理"
        }
      }, {
        path: "certExpired",
        name: "certExpired",
        component: CertExpired,
        meta: {
          title: "资质查询"
        }
      }, {
        path: "certExpiredDetails",
        name: "certExpiredDetails",
        component: CertExpiredDetails,
        meta: {
          title: "资质图片"
        }
      }
      , {
        path: "memTopUp",
        name: "memTopUp",
        component: MemTopUp,
        meta: {
          title: "线下充值",
        },
      },
      {
        path: "RechargeFlow",
        name: "RechargeFlow",
        component: RechargeFlow,
        meta: {
          title: "充值流水",
        },
      }, {
        path: "registAudit",
        name: "registAudit",
        component: RegistAudit,
        meta: {
          title: "注册审核"
        }
      }, {
        path: "registCertificate",
        name: "registCertificate",
        component: RegistCertificate,
        meta: {
          title: "客户维护"
        }
      }, {
        path: "eRPCertificate",
        name: "eRPCertificate",
        component: ERPCertificate,
        meta: {
          title: "ERP分类维护"
        }
      },
      {
        path: "certificate",
        name: "certificate",
        component: Certificate,
        meta: {
          title: "注册资质"
        }
      }, {
        path: "runRange",
        name: "runRange",
        component: RunRange,
        meta: {
          title: "经营范围"
        }
      }, {
        path: "memClassify",
        name: "memClassify",
        component: MemClassify,
        meta: {
          title: "客户分类"
        }
      }, {
        path: "memGroup",
        name: "memGroup",
        component: MemGroup,
        meta: {
          title: "客户分组"
        }
      }, {
        path: "bindUserGroup",
        name: "bindUserGroup",
        component: BindUserGroup,
        meta: {
          title: "绑定客户分组"
        }
      }, {
        path: "topupList",
        name: "topupList",
        component: TopupList,
        meta: {
          title: "充值活动"
        }
      }, {
        path: "topupWater",
        name: "topupWater",
        component: TopupWater,
        meta: {
          title: "充值流水"
        }
      }, {
        path: "signRule",
        name: "signRule",
        component: SignRule,
        meta: {
          title: "签到规则"
        }
      }, {
        path: "signFun",
        name: "signFun",
        component: SignFun,
        meta: {
          title: "签到功能"
        }
      }, {
        path: "themeTem",
        name: "themeTem",
        component: ThemeTem,
        meta: {
          title: "主题活动模板"
        }
      }, {
        path: "themePro",
        name: "themePro",
        component: ThemePro,
        meta: {
          title: "主题商品组合"
        }
      }, {
        path: "templateBind",
        name: "templateBind",
        component: TemplateBind,
        meta: {
          title: "模板绑定"
        }
      }, {
        path: "addTemplate",
        name: "addTemplate",
        component: AddTemplate,
        meta: {
          title: "模板管理",
          show: true
        }
      }, {
        path: "addTemPro",
        name: "addTemPro",
        component: AddTemPro,
        meta: {
          title: "绑定商品",
          show: true
        }
      }, {
        path: "productList",
        name: "productList",
        component: ProductList,
        meta: {
          title: "商品列表"
        }
      }, {
        path: "productImgList",
        name: "productImgList",
        component: ProductImgList,
        meta: {
          title: "商品图片"
        }
      }, {
        path: "addProduct",
        name: "addProduct",
        component: AddProduct,
        meta: {
          title: "商品管理",
          show: true
        }
      }, {
        path: "addImgProduct",
        name: "addImgProduct",
        component: AddImgProduct,
        meta: {
          title: "商品图片管理",
          show: true
        }
      },
      {
        path: "productAreaPrice",
        name: "productAreaPrice",
        component: ProductAreaPrice,
        meta: {
          title: "商品区域价格",
          show: true
        }
      }, {
        path: "priceLevel",
        name: "priceLevel",
        component: PriceLevel,
        meta: {
          title: "价格等级",
          show: true
        }
      }, {
        path: "productClassify",
        name: "productClassify",
        component: ProductClassify,
        meta: {
          title: "商品分类"
        }
      }, {
        path: "classifyGoods",
        name: "classifyGoods",
        component: ClassifyGoods,
        meta: {
          title: "分类商品"
        }
      }, {
        path: "goodsGroup",
        name: "goodsGroup",
        component: GoodsGroup,
        meta: {
          title: "商品分组"
        }
      }, {
        path: "addGoodsGroup",
        name: "addGoodsGroup",
        component: AddGoodsGroup,
        meta: {
          title: "编辑商品分组"
        }
      }, {
        path: "giftList",
        name: "giftList",
        component: GiftList,
        meta: {
          title: "赠品管理"
        }
      }, {
        path: "integralGoods",
        name: "integralGoods",
        component: IntegralGoods,
        meta: {
          title: "积分商品"
        }
      }, {
        path: "controlGoods",
        name: "controlGoods",
        component: ControlGoods,
        meta: {
          title: "商品控销"
        }
      }, {
        path: "recommendGoods",
        name: "recommendGoods",
        component: RecommendGoods,
        meta: {
          title: "推荐商品管理"
        }
      }, {
        path: "addConGoods",
        name: "addConGoods",
        component: AddConGoods,
        meta: {
          title: "商品控销管理",
          show: true
        }
      }, {
        path: "addGift",
        name: "addGift",
        component: AddGift,
        meta: {
          title: "添加赠品",
          show: true
        }
      }, {
        path: "addIntGoods",
        name: "addIntGoods",
        component: AddIntGoods,
        meta: {
          title: "添加积分商品",
          show: true
        }
      }, {
        path: "addProClassify",
        name: "addProClassify",
        component: AddProClassify,
        meta: {
          title: "商品分类管理",
          show: true
        }
      }, {
        path: "addComm",
        name: "addComm",
        component: AddComm,
        meta: {
          title: "新增推荐商品",
          show: true
        }
      }, {
        path: "goodsTag",
        name: "goodsTag",
        component: GoodsTag,
        meta: {
          title: "商品标签"
        }
      },
      {
        path: "wantBuy",
        name: "wantBuy",
        component: WantBuy,
        meta: {
          title: "求购商品"
        }
      },
      {
        path: "inventoryUsage",
        name: "inventoryUsage",
        component: InventoryUsage,
        meta: {
          title: "商品占用库存查询"
        }
      },
      {
        path: "limitMan",
        name: "limitMan",
        component: LimitMan,
        meta: {
          title: "限销管理"
        }
      },
      {
        path: "LimitManCx",
        name: "LimitManCx",
        component: LimitManCx,
        meta: {
          title: "限销管理"
        }
      },
      {
        path: "goodsControl",
        name: "goodsControl",
        component: GoodsControl,
        meta: {
          title: "商品管控"
        }
      },
      {
        path: "controlGroup",
        name: "controlGroup",
        component: ControlGroup,
        meta: {
          title: "控销分组",
          show: true
        }
      }, {
        path: "controlGroupInfo",
        name: "controlGroupInfo",
        component: ControlGroupInfo,
        meta: {
          title: "控销分组管理",
          show: true
        }
      }, {
        path: "groupBind",
        name: "groupBind",
        component: GroupBind,
        meta: {
          title: "分组关系",
          show: true
        }
      }, {
        path: "articleList",
        name: "articleList",
        component: ArticleList,
        meta: {
          title: "文章列表",
          show: true
        }
      }, {
        path: "addArticle",
        name: "addArticle",
        component: AddArticle,
        meta: {
          title: "编辑文章",
          show: true
        }
      }, {
        path: "articleSort",
        name: "articleSort",
        component: ArticleSort,
        meta: {
          title: "文章分类",
          show: true
        }
      }, {
        path: "getGoods",
        name: "getGoods",
        component: GetGoods,
        meta: {
          title: "商品到货管理"
        }
      }, {
        path: "schemes",
        name: "schemes",
        component: Schemes,
        meta: {
          title: "方案列表"
        }
      }, {
        path: "single",
        name: "single",
        component: Single,
        meta: {
          title: "单品方案设计"
        }
      }, {
        path: "group",
        name: "group",
        component: Group,
        meta: {
          title: "组合商品"
        }
      }, {
        path: "promActivityList",
        name: "promActivityList",
        component: PromActivityList,
        meta: {
          title: "促销活动管理"
        }
      }, {
        path: "addPromActivity",
        name: "addPromActivity",
        component: AddPromActivity,
        meta: {
          title: "编辑促销活动"
        }
      }, {
        path: "promRuleList",
        name: "promRuleList",
        component: PromRuleList,
        meta: {
          title: "促销规则管理"
        }
      }, {
        path: "addPromRule",
        name: "addPromRule",
        component: AddPromRule,
        meta: {
          title: "编辑促销规则"
        }
      }, {
        path: "focusBuy",
        name: "focusBuy",
        component: FocusBuy,
        meta: {
          title: "集采列表"
        }
      }, {
        path: "addFocusBuy",
        name: "addFocusBuy",
        component: AddFocusBuy,
        meta: {
          title: "编辑集采列表"
        }
      }, {
        path: "spellGroup",
        name: "spellGroup",
        component: SpellGroup,
        meta: {
          title: "拼团列表"
        }
      }, {
        path: "promAmount",
        name: "promAmount",
        component: PromAmount,
        meta: {
          title: "订单累计金额促销"
        }
      }, {
        path: "addAmount",
        name: "addAmount",
        component: AddAmount,
        meta: {
          title: "新增订单累计金额促销活动"
        }
      }, {
        path: "addSpellGroup",
        name: "addSpellGroup",
        component: AddSpellGroup,
        meta: {
          title: "编辑拼团列表"
        }
      }, {
        path: "coupons",
        name: "coupons",
        component: Coupons,
        meta: {
          title: "优惠券列表"
        }
      }, {
        path: "giveOut",
        name: "giveOut",
        component: GiveOut,
        meta: {
          title: "优惠券下发"
        }
      }, {
        path: "couponDetail",
        name: "couponDetail",
        component: CouponDetail,
        meta: {
          title: "优惠券详情"
        }
      }, {
        path: "userCoupon",
        name: "userCoupon",
        component: UserCoupon,
        meta: {
          title: "客户优惠券"
        }
      }, {
        path: "presell",
        name: "presell",
        component: Presell,
        meta: {
          title: "预售活动管理"
        }
      }, {
        path: "presellForm",
        name: "presellForm",
        component: PresellForm,
        meta: {
          title: "预售编辑"
        }
      }, {
        path: "promMan",
        name: "promMan",
        component: PromMan,
        meta: {
          title: "促销活动管理"
        }
      },
       {
        path: "promForm",
        name: "promForm",
        component: PromForm,
        meta: {
          title: "促销活动管理"
        }
      }, 
      {
        path: "orderList",
        name: "orderList",
        component: OrderList,
        meta: {
          title: "订单列表"
        }
      },
      {
        path: "orderInfo",
        name: "orderInfo",
        component: OrderInfo,
        meta: {
          title: "订单详情"
        }
      },
      {
        path: "returnList",
        name: "returnList",
        component: ReturnList,
        meta: {
          title: "退货申请"
        }
      },
      {
        path: "chuFangList",
        name: "chuFangList",
        component: ChuFangList,
        meta: {
          title: "处方申请"
        }
      },
      {
        path: "orderRefund",
        name: "orderRefund",
        component: OrderRefund,
        meta: {
          title: "退款申请"
        }
      }, {
        path: "focusOrder",
        name: "focusOrder",
        component: FocusOrder,
        meta: {
          title: "集采订单"
        }
      }, {
        path: "spellOrder",
        name: "spellOrder",
        component: SpellOrder,
        meta: {
          title: "拼团订单"
        }
      }, {
        path: "expenseWater",
        name: "expenseWater",
        component: ExpenseWater,
        meta: {
          title: "消费流水"
        }
      }, {
        path: "giftExchange",
        name: "giftExchange",
        component: GiftExchange,
        meta: {
          title: "赠品兑换单"
        }
      },
      {
        path: "orderSummary",
        name: "orderSummary",
        component: OrderSummary,
        meta: {
          title: "订单汇总"
        }
      },
      {
        path: "orderDetails",
        name: "orderDetails",
        component: OrderDetails,
        meta: {
          title: "订单明细查询"
        }
      },

      {
        path: "integralList",
        name: "integralList",
        component: IntegralList,
        meta: {
          title: "积分订单"
        }
      }, {
        path: "integralWater",
        name: "integralWater",
        component: IntegralWater,
        meta: {
          title: "积分流水"
        }
      }, {
        path: "retreatAudit",
        name: "retreatAudit",
        component: RetreatAudit,
        meta: {
          title: "退单审核"
        }
      }, {
        path: "refundRequest",
        name: "refundRequest",
        component: RefundRequest,
        meta: {
          title: "退款单申请"
        }
      }, {
        path: "RefundRequestDetail",
        name: "RefundRequestDetail",
        component: RefundRequestDetail,
        meta: {
          title: "退款审核详情"  
        }
      }, {
        path: "payQuery",
        name: "payQuery",
        component: PayQuery,
        meta: {
          title: "在线支付查询"
        }
      }, {
        path: "invoiceRequestRecord",
        name: "invoiceRequestRecord",
        component: InvoiceRequestRecord,
        meta: {
          title: "发票申请记录"
        }
      }, {
        path: "commentAudit",
        name: "commentAudit",
        component: CommentAudit,
        meta: {
          title: "商品评论"
        }
      }, {
        path: "prefectureList",
        name: "prefectureList",
        component: PrefectureList,
        meta: {
          title: "品牌管理"
        }
      }, {
        path: "homeBrand",
        name: "homeBrand",
        component: HomeBrand,
        meta: {
          title: "首页品牌管理"
        }
      }, {
        path: "pharmacyZone",
        name: "pharmacyZone",
        component: PharmacyZone,
        meta: {
          title: "药店专区管理"
        }
      }, {
        path: "prefectureGoods",
        name: "prefectureGoods",
        component: PrefectureGoods,
        meta: {
          title: "品牌商品"
        }
      },
      {
        path: "expertList",
        name: "expertList",
        component: ExpertList,
        meta: {
          title: "专区列表"
        }
      },
      {
        path: "outpatientZone",
        name: "outpatientZone",
        component: OutpatientZone,
        meta: {
          title: "专区商品"
        }
      }, {
        path: "prizeList",
        name: "prizeList",
        component: PrizeList,
        meta: {
          title: "奖品列表"
        }
      }, {
        path: "prizeRule",
        name: "prizeRule",
        component: PrizeRule,
        meta: {
          title: "抽奖规则"
        }
      }, {
        path: "recorded",
        name: "recorded",
        component: Recorded,
        meta: {
          title: "中奖记录"
        }
      }, {
        path: "logIp",
        name: "logIp",
        component: LogIp,
        meta: {
          title: "用户IP捕捉记录"
        }
      }, {
        path: "handleLog",
        name: "handleLog",
        component: HandleLog,
        meta: {
          title: "用户IP捕捉记录"
        }
      }, {
        path: "dataCount",
        name: "dataCount",
        component: DataCount,
        meta: {
          title: "数据统计"
        }
      }, {
        path: "collect",
        name: "collect",
        component: Collect,
        meta: {
          title: "收藏统计"
        }
      }, {
        path: "orderFrequency",
        name: "orderFrequency",
        component: OrderFrequency,
        meta: {
          title: "下单频率分析"
        }
      }, {
        path: "ordersellAnalysis",
        name: "ordersellAnalysis",
        component: OrdersellAnalysis,
        meta: {
          title: "下单频率分析"
        }
      }, {
        path: "orderSource",
        name: "orderSource",
        component: OrderSource,
        meta: {
          title: "订单来源统计"
        }
      }, {
        path: "orderTime",
        name: "orderTime",
        component: OrderTime,
        meta: {
          title: "下单时间统计"
        }
      }, {
        path: "searchFrequency",
        name: "searchFrequency",
        component: SearchFrequency,
        meta: {
          title: "搜索频率分析"
        }
      }, {
        path: "shopCart",
        name: "shopCart",
        component: ShopCart,
        meta: {
          title: "购物车商品分析"
        }
      }, {
        path: "typePay",
        name: "typePay",
        component: TypePay,
        meta: {
          title: "支付类型统计"
        }
      }, {
        path: "unitPrice",
        name: "unitPrice",
        component: UnitPrice,
        meta: {
          title: "客单价统计"
        }
      }, {
        path: "loginList",
        name: "loginList",
        component: LoginList,
        meta: {
          title: "登录统计"
        }
      }, {
        path: "orderAnalysis",
        name: "orderAnalysis",
        component: OrderAnalysis,
        meta: {
          title: "订单分析"
        }
      }, {
        path: "userAnalysis",
        name: "userAnalysis",
        component: UserAnalysis,
        meta: {
          title: "客户分析"
        }
      }, {
        path: "goodsAnalysis",
        name: "goodsAnalysis",
        component: GoodsAnalysis,
        meta: {
          title: "商品分析"
        }
      }, {
        path: "userGoods",
        name: "userGoods",
        component: UserGoods,
        meta: {
          title: "客户商品"
        }
      }, {
        path: "orderInterface",
        name: "orderInterface",
        component: OrderInterface,
        meta: {
          title: "订单接口"
        }
      }, {
        path: "orderInterfaceInfo",
        name: "orderInterfaceInfo",
        component: OrderInterfaceInfo,
        meta: {
          title: "订单接口详情"
        }
      }, {
        path: "goodsInterface",
        name: "goodsInterface",
        component: GoodsInterface,
        meta: {
          title: "商品接口"
        }
      }, {
        path: "userInterface",
        name: "userInterface",
        component: UserInterface,
        meta: {
          title: "客户接口"
        }
      }, {
        path: "priceInterface",
        name: "priceInterface",
        component: PriceInterface,
        meta: {
          title: "价格接口"
        }
      }, {
        path: "imgMan",
        name: "imgMan",
        component: ImgMan,
        meta: {
          title: "图片管理"
        }
      },
      {
        path: "appBanner",
        name: "appBanner",
        component: AppBanner,
        meta: {
          title: "APP横幅图片"
        }
      },
      {
        path: "studyBanner",
        name: "studyBanner",
        component: StudyBanner,
        meta: {
          title: "APP要学习轮播图"
        }
      },
      {
        path: "appAdvertImgs",
        name: "appAdvertImgs",
        component: AppAdvertImgs,
        meta: {
          title: "广告图详情"
        }
      },
      {
        path: "pcBanner",
        name: "pcBanner",
        component: PcBanner,
        meta: {
          title: "PC横幅图片"
        }
      }, {
        path: "pcBannerList",
        name: "pcBannerList",
        component: PcBannerList,
        meta: {
          title: "轮播图管理"
        }
      }, {
        path: "bannerList",
        name: "bannerList",
        component: BannerList,
        meta: {
          title: "APP轮播图管理"
        }
      }, {
        path: "floorList",
        name: "floorList",
        component: FloorList,
        meta: {
          title: "楼层图片"
        }
      }, {
        path: "informMan",
        name: "informMan",
        component: InformMan,
        meta: {
          title: "消息管理"
        }
      }, {
        path: "addAdvisory",
        name: "addAdvisory",
        component: AddAdvisory,
        meta: {
          title: "消息编辑"
        }
      }, {
        path: "homeSystem",
        name: "homeSystem",
        component: homeSystem,
        meta: {
          title: "首页设置"
        }
      }, {
        path: "advisoryManLits",
        name: "advisoryManLits",
        component: advisoryManLits,
        meta: {
          title: "编辑"
        }
      }, {
        path: "advisoryMan",
        name: "advisoryMan",
        component: AdvisoryMan,
        meta: {
          title: "消息管理"
        }
      }, {
        path: "helps",
        name: "helps",
        component: Helps,
        meta: {
          title: "帮助中心"
        }
      }, {
        path: "viewDoc",
        name: "viewDoc",
        component: ViewDoc,
        meta: {
          title: "帮助文档列表"
        }
      }, {
        path: "knowleDoc",
        name: "knowleDoc",
        component: KnowleDoc,
        meta: {
          title: "健康知识列表"
        }
      }, {
        path: "EditKnow",
        name: "EditKnow",
        component: EditKnow,
        meta: {
          title: "编辑健康知识"
        }
      },
      {

        path: "editDoc",
        name: "editDoc",
        component: EditDoc,
        meta: {
          title: "帮助文档编辑"
        }
      }, {
        path: "leavingMsg",
        name: "leavingMsg",
        component: LeavingMsg,
        meta: {
          title: "留言管理"
        }
      }, {
        path: "salesmanGroup",
        name: "salesmanGroup",
        component: SalesmanGroup,
        meta: {
          title: "业务员分组",
        }
      }, {
        path: "bindGroup",
        name: "bindGroup",
        component: BindGroup,
        meta: {
          title: "绑定分组"
        }
      }, {
        path: "salesmanList",
        name: "salesmanList",
        component: SalesmanList,
        meta: {
          title: "业务员列表"
        }
      }, {
        path: "duoJiSalesmanList",
        name: "duoJiSalesmanList",
        component: DuoJiSalesmanList,
        meta: {
          title: "多级业务员列表"
        }
      },{
        path: "duoJiSalesBangDingGoods",
        name: "duoJiSalesBangDingGoods",
        component: DuoJiSalesBangDingGoods,
        meta: {
          title: "多级业务员绑定商品"
        }
      },{
        path: "duoJiSalesChangeLeader",
        name: "duoJiSalesChangeLeader",
        component: DuoJiSalesChangeLeader,
        meta: {
          title: "多级业务员更换上级"
        }
      },{
        path: "duoJiSalesChangeTransfer",
        name: "duoJiSalesChangeTransfer",
        component: DuoJiSalesChangeTransfer,
        meta: {
          title: "多级业务员迁移下级"
        }
      },{
        path: "dotoclist",
        name: "dotoclist",
        component: Dotoclist,
        meta: {
          title: "医生列表"
        }
      }, {
        path: "doictSickLits",
        name: "doictSickLits",
        component: DoictSickLits,
        meta: {
          title: "患者列表"
        }
      }, {
        path: "knowledgelits",
        name: "knowledgelits",
        component: Knowledgelits,
        meta: {
          title: "健康知识"
        }
      }, {
        path: "SalesmanListDoict",
        name: "SalesmanListDoict",
        component: SalesmanListDoict,
        meta: {
          title: "业务员医生列表"
        }
      }, {
        path: "salesmanUser",
        name: "salesmanUser",
        component: SalesmanUser,
        meta: {
          title: "业务员客户列表"
        }
      }, {
        path: "salesmanReg",
        name: "salesmanReg",
        component: SalesmanReg,
        meta: {
          title: "业务员注册"
        }
      }, {
        path: "salesmanOrderList",
        name: "salesmanOrderList",
        component: SalesmanOrderList,
        meta: {
          title: "业务员订单列表"
        }
      }, {
        path: "salesmanAudit",
        name: "salesmanAudit",
        component: SalesmanAudit,
        meta: {
          title: "业务员审核"
        }
      }, {
        path: "SalesmanCommodity",
        name: "SalesmanCommodity",
        component: SalesmanCommodity,
        meta: {
          title: "业务员绑定商品"
        }
      }, {
        path: "BindingSalesman",
        name: "BindingSalesman",
        component: BindingSalesman,
        meta: {
          title: "绑定业务员"
        }
      }, {
        path: "salesmanRole",
        name: "salesmanRole",
        component: SalesmanRole,
        meta: {
          title: "业务员角色"
        }
      }

    ]
  }
]

const router = new VueRouter({
  routes,
  mode: "hash"
});


//获取该权限数据


router.beforeEach((to, from, next) => {
  //修改标题
  //从from跳转到to里面去
  //to：表示当前路由，meta实在路由映射中配置的静态资源
  //如果以上述方式修改title的话，有嵌套其他组件的组件将会显示不正常
  // document.title = to.matched[0].meta.title;
  let vm = null
  for (let i = 0; i < to.matched.length; i++) {
    let item = to.matched[i]
    if (item.path == to.path) {
      vm = item.instances.default
      break
    }
  }
  if (vm) {
    vm.updata && vm.updata()
  }

  // 路由拦截
  if (to.path == '/login') {//如果是登录直接跳转
    next()
    document.title = to.meta.title
  } else {//判断是否有token
    let auth = window.localStorage.getItem('auth')
    if (auth) {//判断是否有权限
      if (store.state.limitPath.indexOf(to.name) != -1 || to.name == 'firstPage' || to.meta.show) {
        //修改页面的title
        next()
        document.title = to.meta.title
      } else {
        next()
        document.title = to.meta.title
        // next('/home/firstPage');
      }
    } else {//没有token跳转到首页
      clearUserInfo()
      Message({
        title: '提示',
        type: "warning",
        message: '请先登录'
      })
      next({
        path: '/login',
        query: {
          redirect: "redirect"
        }
      })
    }
  }
})

export default router